import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-del-req',
  templateUrl: './del-req.component.html',
  styleUrls: ['./del-req.component.css']
})
export class DelReqComponent implements OnInit {
	respObject: any;
	reqData: any;

	dataType = "";
	fileYear="";
	fullYear: number = new Date().getFullYear();
	yearArr= [];
	yearfArr= [];
	filefYear="";
	selectMonth="";
	fileQuarter="";
	isEmpty=true;
	status="";
	
  

	perPageRow = this._rest.PER_PAGE_ROW;
	curPage = 1;
	totalRows = 0;
	pages = [];
	noOfRows=0;
	constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { }

	ngOnInit(): void {
		this.dataType = "";
	    this.selectMonth="";
	    this.fileQuarter="";
	   // this.companyId="";
	   this.status="";
	    for (var i= this.fullYear-10;i<=this.fullYear;i++){
	      this.yearArr.push(i);
	      //this.fileYear= i+"";
	    }
	    for (var i= this.fullYear-10;i<=this.fullYear;i++){
	      this.yearfArr.push(i+"-"+(i+1));
	      //this.filefYear = i+"-"+(i+1);
	    }
	    this.searchPenReq(1);
		/*const data = {
			"companyId":localStorage.getItem('companyId')
		}
		//console.log(data)
		this._rest.getDelRequest(data).subscribe((res) => {
			console.log(res);
			this.respObject=res;
			if(this.respObject.error==0){
				this.reqData=this.respObject.resp;
			} else {
				console.log(this.respObject.errorMessage);
			}
			
		});*/
	}
	searchPenReq(curPage){
		this.curPage= curPage;
		const searchData = {
		  "page": this.curPage,
		  "limit":this.perPageRow,
		  "companyId":localStorage.getItem('companyId')
		};
		if(this.dataType!=""){
	    	searchData["templateType"]=this.dataType;
	    }
	    if(this.status!=""){
	    	searchData["status"]=this.status;
	    }
	    if(this.dataType == "Segment"){
	      searchData["year"]=this.fileYear;
	      searchData["month"]=this.selectMonth;
	    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){     
	      searchData["year"]=this.filefYear;
	      searchData["quarter"]=this.fileQuarter;
	    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){     
	      searchData["year"]=this.filefYear;
	    }
		if(this.dataType == "Flash"){
			searchData['request'] = 'edit';
		}else{
			if(this.dataType != ''){
				searchData['request'] = 'delete';
			}
			else{
				searchData['request'] = '';
			}
		}
	    
		this.reqData = [];
		this._rest.getDelRequest(searchData).subscribe((res) => {
		  this.respObject = res;
		  if(this.respObject.error==0){

		    this.reqData = this.respObject.resp.data;
		    this.totalRows = this.respObject.resp.info;
		    this.noOfRows=this.respObject.resp.data.length;
		    if(this.reqData.length>0){
				this.isEmpty = false;
			} else {
				this.isEmpty = true;
			}
		    this.pages=[];
		    for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
		      this.pages.push(i);
		    }
		  } else {
		  	this.isEmpty = true;
		    this.totalRows = 0;
		    this.noOfRows = 0;
		    this.pages=[];
		    this.reqData=[];
		  }
		  //console.log(JSON.stringify(this.respPeer));
		  
		})
	}

}
